import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import "./styles/global.less";
import $ from "./lib/jQuery";
import 'animate.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI,{ size:'small' });
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
